import { render } from "./icon-pen.vue?vue&type=template&id=42d347e2"
import script from "./icon-pen.vue?vue&type=script&lang=js"
export * from "./icon-pen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__